import React, {memo} from "react";

// import logo from '@/static/logo2.png'
// import logo from '@/static/logo-tm.png'
import Main from "./main";
import {useAuth0} from "@auth0/auth0-react";
import Result from "@/pages/Index/Result";


interface Props {
}

/**
 * 主页面组件 - 包含主要内容区域和结果展示区域
 * 使用flex布局确保在不同设备和缩放比例下的一致性
 */
const Index: React.FC<Props> = memo(() => {
  return (
    <>
      <div className="text-black h-full">
        <div className="flex flex-row h-full gap-3">
          {/*<div className="shadow-2xs w-58 bg-[#FAFAFA] border-gray-200 card  flex-none rounded-2xl">*/}
          {/*  <div className="card-body p-4 overflow-y-auto " style={{scrollbarWidth:"none"}}>*/}
          {/*    <History/>*/}
          {/*  </div>*/}
          {/*</div>*/}

          <Main />
          <Result historyItem={undefined} />
        </div>
      </div>
    </>
  );
});
Index.displayName = "Index";

export default Index;